import { Reseller } from '@ViewModels';
import * as React from 'react';
import { getLogoComponent } from '../utils/resellerLogoResolver';

interface IProps {
	className?: string;
	height?: number;
	width?: number;
	textColor?: string;
	/**
	 * The reseller type to determine which logo to display.
	 * If not provided, defaults to Levitate logo.
	 */
	reseller?: Reseller;
}

/**
 * Dynamic logo component that renders the appropriate logo based on reseller.
 * This component provides indirection for logo selection.
 *
 * @example
 * // Default Levitate logo
 * <ResellerLogoIcon />
 *
 * @example
 * // Cambridge logo
 * <ResellerLogoIcon reseller={Reseller.Cambridge} />
 */
export const ResellerLogoIcon: React.FC<IProps> = ({ reseller, ...props }) => {
	const LogoComponent = getLogoComponent(reseller);
	return <LogoComponent {...props} />;
};
